import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { HubReportsService } from '../../services/hub-reports/hub-reports.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { FiltersComponent } from '../filters-component';
import { HubReport } from '../../interfaces/hub-reports/hub-report';
import { HttpParams } from '@angular/common/http';
import { eHubReportType } from '../../enums';

@Component({
  selector: 'lib-hub-reports-v2-filter',
  templateUrl: './hub-reports-v2-filter.component.html',
  styleUrl: './hub-reports-v2-filter.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class HubReportsV2FilterComponent extends FiltersComponent<HubReport> implements OnInit, OnDestroy {
  protected isAdmin = true; //UBO2TODO: remove this after envelopes are gone

  constructor(
    hubReportsService: HubReportsService,
    formBuilder: FormBuilder,
    datePipe: DatePipe) {
    super(hubReportsService, formBuilder, datePipe);
  }

  ngOnInit(): void {
    this._filterForm = this.formBuilder.group({
      reference: [null],
      envelopeID: [null], //UBO2TODO: remove this after envelopes are gone
      businessName: [null],
      businessNumber: [null],
      country: [null],
      jurisdiction: [null]
    });

    this._defaultParams = this.buildParamsFromForm(this._filterForm);
    let params = new HttpParams()
      .append('HubReportType', eHubReportType.ultimateBeneficialOwnership);
    this.repo.getFirstPage(params);
  }

  ngOnDestroy(): void {
    this.repo.clearFilters();
  }

  protected handleJurisdictionFormReady(event: FormGroup) {
    this._filterForm.setControl('country', event);
  }
}
